module.exports = __webpack_public_path__ + "img/pinduoduo.717751e.svg";